import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import routes from "routes";
const PopupLogout = (props) => {
  const location = useLocation();

  const [active, setActive] = useState(null);
  const [namePage, setNamePage] = useState("Home");
  const navigate = useNavigate();

  const handleNavigate = (e, params) => {
    props.handleCloseNav();
    navigate(e, params ? { state: { scrollToJoin: true } } : {});
  };
  const handleScroll = (elementId) => {
    document.getElementById(elementId).scrollIntoView({ behavior: "smooth" });
  };
  const tmp = [
    {
      name: "giới thiệu",
      action: () => handleScroll("introduce"),
    },
    {
      name: "quy định",
      action: () => handleScroll("rule"),
    },
    {
      name: "trang chủ",
      action: () => window.scrollTo(0, 0),
    },
  ];

  // const tmp = [...routes]

  return (
    <>
      <div className="popup-overlay modal-top move">
        <div className="popup-warp">
          <div className="popup-inner">
            <div className="content-popup">
              <ul>
                {tmp.map((link, index) => {
                  return (
                    <>
                      <>
                        <li key={index} className="nav-item">
                          <a
                            style={{ textTransform: "capitalize" }}
                            className={`nav-link ${
                              active == link.path && "active"
                            }`}
                            onClick={() => {
                              link.action();
                              props.handleCloseNav();
                            }}
                          >
                            {link.name}
                          </a>
                        </li>
                      </>
                    </>
                  );
                })}
              </ul>
            </div>
          </div>
          <div className="close-nav" onClick={props.handleCloseNav}></div>
        </div>
      </div>
    </>
  );
};
export default PopupLogout;
